// extracted by mini-css-extract-plugin
export default {"container":"TenantDetailPage_container__OvJ5v"};